import React from "react";
import { TimePicker } from "antd";

const TimeDeparture = ({ index, values, handleChange }) => {
  return (
    // <TimePicker
    //   className="form-control"
    //   style={{
    //     width: "98%",
    //     borderRadius: "4px",
    //     // border:
    //     //   touched.flightLegs &&
    //     //   touched.flightLegs[index].departureTime &&
    //     //   !timeDeparture[index].time &&
    //     //   "1px solid red",
    //   }}
    //   id={`flightLegs.return[${index}]departureTime`}
    //   name={`flightLegs.return[${index}]departureTime`}
    //   use24Hours
    //   value={timeDeparture[index]?.time}
    //   onChange={(time, timeString) =>
    //     changeTimeDepartureInput(time, timeString, index)
    //   }
    //   required
    // />
    <>
      <input
        placeholder="hh:mm"
        type="time"
        className="form-control" // name="arrivalTime"
        id={`flightLegs.return[${index}].departureTime`}
        name={`flightLegs.return[${index}].departureTime`}
        // display="Request Date"
        // onBlur={handleBlur}
        value={values?.flightLegs?.return[index]?.departureTime}
        onChange={handleChange}
      />
    </>
  );
};

export default TimeDeparture;
